import React, { FC, useContext } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { BannersContext, useRuntimeConfig } from "@finbackoffice/site-core";
import Translate from "components/base/translate/Translate";
import BannersSlider from "components/base/banners-slider/BannersSlider";
import Img from "components/base/img/Img";
import styles from "../bonuses.module.sass";

const BonusesReferral: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    const { banners } = useContext(BannersContext);

    return (
        <section className={styles.navContent}>
            <h1 className={styles.header} data-testid="bonus-referral-heading">
                <Img
                    source={`${ASSETS_URL}/common/desktop/bonuses/bonuses-referral.svg`}
                    alt="Referral"
                    width={20}
                    height={20}
                />
                <Translate
                    tid="bonuses_referral_heading"
                    namespace={TranslationScopes.BonusesReferral}
                />
            </h1>
            <h2>
                <Translate
                    tid="bonuses_referral_sub_heading"
                    namespace={TranslationScopes.BonusesReferral}
                />
            </h2>
            <BannersSlider
                banners={banners}
                wrapperClassName={styles.bannerContainer}
                imgProps={{
                    width: 0,
                    height: 0,
                }}
            />
            <h2>
                <Translate
                    tid="bonuses_referral_text"
                    namespace={TranslationScopes.BonusesReferral}
                />
            </h2>
            <ol>
                <Translate
                    dangerous
                    tid="bonuses_referral_point1"
                    namespace={TranslationScopes.BonusesReferral}>
                    <li />
                </Translate>
                <Translate
                    dangerous
                    tid="bonuses_referral_point2"
                    namespace={TranslationScopes.BonusesReferral}>
                    <li />
                </Translate>
            </ol>
            <br />
            <Translate
                dangerous
                tid="bonuses_referral_bottomText"
                namespace={TranslationScopes.BonusesReferral}>
                <div className={styles.referralBottomTxt} />
            </Translate>
        </section>
    );
};

export default BonusesReferral;
